import { render, staticRenderFns } from "./Paises.vue?vue&type=template&id=344f9530&scoped=true&"
import script from "./Paises.vue?vue&type=script&lang=js&"
export * from "./Paises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344f9530",
  null
  
)

export default component.exports